export default "__VITE_PUBLIC_ASSET__5319377d__"